/**
 * ConsoleLogger Component
 *
 * This component logs "Hello World" to the browser console when the application loads.
 * It serves as a simple demonstration of application initialization logging
 * and can be extended for debugging purposes.
 *
 * @component
 */

import { useEffect } from 'react';

/**
 * ConsoleLogger - A React component that logs a welcome message to the browser console
 *
 * @returns {null} This component doesn't render any visible UI
 */
function ConsoleLogger() {
  useEffect(() => {
    // Log "Hello World" message when component mounts
    // This confirms the application has loaded successfully
    console.log('Hello World');

    // No cleanup needed for this simple logging operation
  }, []); // Empty dependency array ensures this runs once on mount

  // Component doesn't render any visible UI
  return null;
}

export default ConsoleLogger;